import useAddCompletedOnboardingItems from './useAddCompletedOnboardingItems';

export default useAddCompletedOnboardingItems;
